import React from 'react';
import {
  ActionList,
  ActionListItem,
  Dropdown,
  DropdownOverlay,
  FilterChipGroup,
  FilterChipSelectInput,
} from '@razorpay/blade/components';
import { employeeSubTypeActionListOptions } from 'constants/employeeSubType';

type PeopleFiltersProps = {
  employeeSubType: string;
  onEmployeeSubTypeChange: (value: string) => void;
};

export const PeopleFilters = ({ employeeSubType, onEmployeeSubTypeChange }: PeopleFiltersProps) => {
  return (
    <FilterChipGroup onClearButtonClick={() => onEmployeeSubTypeChange('')}>
      <Dropdown selectionType="single">
        <FilterChipSelectInput
          name="employeeSubType"
          label="Employee Type"
          value={employeeSubType}
          onClearButtonClick={() => onEmployeeSubTypeChange('')}
          onChange={({ values }) => onEmployeeSubTypeChange(values[0] ?? '')}
          accessibilityLabel="Employee Type filter"
        />
        <DropdownOverlay>
          <ActionList>
            {employeeSubTypeActionListOptions.map((option) => (
              <ActionListItem key={option.value} title={option.title} value={option.value} />
            ))}
          </ActionList>
        </DropdownOverlay>
      </Dropdown>
    </FilterChipGroup>
  );
};
